// The shareable address of a replay: this page with ?replay=<id> and nothing else from the current query
// (a ?room or ?hero would send the friend somewhere else first).
import { FRESH_REPLAY_HASH } from '../screens.js';

export function replayLink(id: string, loc: Pick<Location, 'origin' | 'pathname'> = location): string {
  return `${loc.origin}${loc.pathname}?replay=${encodeURIComponent(id)}`;
}

/** Where the results screen's «Смотреть повтор» goes: the same page, told the file may still be on its way. */
export function freshReplayLink(id: string, loc: Pick<Location, 'origin' | 'pathname'> = location): string {
  return replayLink(id, loc) + FRESH_REPLAY_HASH;
}
